/** @format */
import { ScoreCardType } from "@roadflex/types";
import classNames from "classnames";
import React from "react";

interface SavingsAndResultsProps {
  scorecards: ScoreCardType[];
  themeColor?: string;
  showHeader?: boolean;
  showFooter?: boolean;
  customerSuccessPage?: boolean;
  promotionPage?: boolean;
  ejwardPage?: boolean;
}

export default function SavingsAndResults(props: SavingsAndResultsProps) {
  const {
    scorecards = [],
    themeColor,
    showHeader = true,
    showFooter = false,
    customerSuccessPage = false,
    promotionPage = false,
    ejwardPage = false,
  } = props;
  return (
    <div
      className={classNames(
        customerSuccessPage
          ? "w-full h-full bg-cover bg-stary-background text-brown-200"
          : promotionPage
          ? "bg-panel-background w-full h-full bg-cover text-white"
          : "w-full h-full bg-white text-black",
      )}
    >
      <div className="container w-full py-14 md:py-32">
        {showHeader && (
          <div
            className={classNames(
              "text-3xl md:text-4xl 3xl:text-5xl text-center mx-auto max-w-[fit-content] font-bold mb-8",
              themeColor ? `text-${themeColor}` : "text-brown-900",
            )}
          >
            Immediate Savings. Immediate Results.
          </div>
        )}
        {showHeader && (
          <div className="text-base md:text-lg 3xl:text-xl text-center mx-auto max-w-[fit-content] mb-16">
            Increase your profits. Eliminate inefficiencies in your expense
            management system.
          </div>
        )}
        {promotionPage && (
          <>
            <div
              className={classNames(
                "text-3xl md:text-4xl 3xl:text-5xl text-center mx-auto max-w-[fit-content] font-bold mb-8",
                themeColor ? `text-${themeColor}` : "text-white",
              )}
            >
              Zero-Fees, Universally Accepted Fleet Card
            </div>
            <div className="text-base md:text-lg 3xl:text-xl text-center mx-auto max-w-[fit-content] mb-16 text-white">
              Avoid card fees, hidden fees and unfair penalties with RoadFlex
            </div>
          </>
        )}
        {ejwardPage && (
          <>
            <div
              className={classNames(
                "text-3xl md:text-4xl 3xl:text-5xl text-center mx-auto max-w-[fit-content] font-bold mb-8",
                themeColor ? `text-${themeColor}` : "text-white",
              )}
            >
              Fuel Cards Were Broken. We Fixed Them.
            </div>
            <div className="text-base md:text-lg 3xl:text-xl text-center mx-auto max-w-[fit-content] mb-16 text-black">
              Next-Generation Fuel Risk Management Solution that eliminate
              inefficiencies in your expense and fuel management.
            </div>
          </>
        )}
        <div className="w-full space-y-14 md:space-y-24">
          <div className="flex flex-col items-stretch justify-between w-full h-full space-y-8 text-white lg:space-y-0 lg:flex-row">
            {scorecards.length > 0 &&
              scorecards.map((scorecard, idx: number) => (
                <React.Fragment key={idx}>
                  {idx % 2 === 0 && (
                    <div
                      className={`flex flex-col items-center h-auto text-center w-full px-8`}
                    >
                      {idx % 2 === 0 && (
                        <div className="max-w-[300px] flex flex-col items-center">
                          <div
                            className={classNames(
                              customerSuccessPage || promotionPage
                                ? "text-white"
                                : "text-black",
                              "pb-4 font-semibold md:text-xl",
                            )}
                          >
                            {scorecard.header}
                          </div>
                          <div className="">
                            <div
                              className={classNames(
                                themeColor === "fleetupBlue"
                                  ? "text-fleetupYellow"
                                  : ejwardPage
                                  ? "text-ejWardNavyBlue"
                                  : "text-orange-500",
                                "flex flex-row items-center pb-4 text-3xl md:text-5xl font-semibold",
                              )}
                            >
                              {scorecard.stats}
                            </div>
                          </div>
                          <div
                            className={classNames(
                              customerSuccessPage || promotionPage
                                ? "text-white"
                                : "text-black",
                              "font-semibold md:text-xl",
                            )}
                          >
                            {scorecard.statsDescription}
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  {idx % 2 === 1 && (
                    <div
                      className={
                        themeColor === "fleetupBlue"
                          ? `hidden lg:block transition-all duration-700 ease-in-out w-1 border-0 transform  bg-fleetupYellow opacity-80`
                          : ejwardPage
                          ? `hidden lg:block transition-all duration-700 ease-in-out w-1 border-0 transform bg-ejWardNavyBlue opacity-80`
                          : `hidden lg:block transition-all duration-700 ease-in-out w-1 border-0 transform opacity-80 bg-gradient-to-b from-orange-300 via-orange-700 to-orange-300`
                      }
                    ></div>
                  )}
                </React.Fragment>
              ))}
          </div>
        </div>
        {showFooter && (
          <div>
            {!customerSuccessPage && (
              <div className="container text-3xl md:text-4xl 3xl:text-5xl text-center mx-auto max-w-[fit-content] font-bold my-14 md:mt-28">
                Dedicated Customer Support and Success
              </div>
            )}
            {customerSuccessPage && (
              <div className="container text-3xl md:text-4xl 3xl:text-5xl text-center mx-auto max-w-[fit-content] font-bold my-14 md:mt-28 inline-block text-transparent bg-gradient-to-r from-orange-500 via-brown-500 to-yellow-500 bg-clip-text">
                Dedicated Customer Support and Success
              </div>
            )}
            <div className="container md:text-lg 3xl:text-xl text-center mx-auto max-w-[fit-content] mt-4 md:mt-0">
              Standard customer service doesn&apos;t fit every fleet, especially
              complex ones. And as your fleet evolves, you may need additional
              resources, dedicated account support and tailored training for
              employees using RoadFlex. Our fleet advisors will work with you to
              make the most of your RoadFlex investment, including remote and
              onsite solutions expertise.
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
